import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation, withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import classNames from 'classnames';
import { withRouter } from 'react-router';

import Badge from '@mui/material/Badge'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography';

import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined'
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

import NumberFormat, { FORMAT_CURRENCY } from 'cityads-v3/components/Format/NumberFormat';
import Credits from 'cityads-v3/containers/webmaster/profile/Credits';

import {
  USER_ROLE_CODE_WEBMASTER,
} from 'cityads-v3/reducers/auth';

import classes from './HeaderToolbar.scss';
import ButtonWithPopover from './ButtonWithPopover'
import { RootState } from 'cityads-v3/types/reducer';

const ALLOWED_ROLES = [USER_ROLE_CODE_WEBMASTER];

export default function HeaderCredits() {
  const { t } = useTranslation(['main'])
  const user = useSelector((state: RootState) => state.auth.user)
  const balance = useSelector((state: RootState) => state.auth.balance || {})
  const isMobile = useSelector((state: RootState) => state.app.isMobile)
  const needDocumentForPayment = useSelector((state: RootState) => state.header.needDocumentForPayment)

  const show = user && ALLOWED_ROLES.indexOf(user.user_role_code) !== -1;

  if (!show) {
    return null;
  }

  if (isMobile) {
    return (
      <Tooltip title={t('profile.credits')}>
        <IconButton component={Link} to={'/publisher/profile/credits'} size="large">
          <Badge
            badgeContent={'!'}
            color="primary"
            invisible={!needDocumentForPayment}
          >
            <AccountBalanceWalletOutlinedIcon className={classes.headerIcon} />
          </Badge>
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <>
      <ButtonWithPopover
        popoverContentRenderer={({ onClose }) => <Credits onClose={onClose} />}
      >
        <Badge
          badgeContent={'!'}
          color="primary"
          invisible={!needDocumentForPayment}
          className={classNames(classes.headerIcon, classes.dropdownIcon)}
        >
          <AccountBalanceWalletOutlinedIcon />
        </Badge>
        <span className={classes.dropdownItemText}>
          <Typography color="textPrimary" variant="caption">
            <NumberFormat
              number={balance.available}
              format={FORMAT_CURRENCY}
              currency={balance.currency}
            />
          </Typography>
        </span>
        <KeyboardArrowDownOutlinedIcon className={classes.arrowDown} />
      </ButtonWithPopover>
    </>
  );
}
